( function() {
console.log(123); 
    const qs = (selector) => {
      return document.querySelector(selector);
    }

    const set_prop = (selector, prop, val) => {
        const el = qs(selector);
        console.log(89);
        if(! el) {
            console.log('not found: ', el);
            return;
        }

        el.style.setProperty(prop, val);
    }

    wp.customize( 'scr_content_bg_colour', ( settings ) => {
        settings.bind((to) => {
            if(to) {
               set_prop( '.lf-content','--content-bg-color', to);
            }
        });
    });

    wp.customize( 'scr_content_colour', ( settings ) => {
        settings.bind((to) => {
            if(to) {
        //       set_prop( '.lf-content', '--content-color', to);
            }
        });
    });

    wp.customize( 'scr_content_link_colour', ( settings ) => {
        settings.bind((to) => {
            if(to) {
            //   set_prop( '.lf-content a', '--content-link-color', to);

               const lfContent = qs('.lf-content');
               if(lfContent) {
                 lfContent.style.background = 'red';
               }
            }
        });
    });

    wp.customize( 'scr_site_bg_colour', function( settings ) {
        settings.bind( function(to) {
             set_prop( 'body', '--site-bg-color', to);
        } )
    });

    wp.customize( 'scr_header_bg_colour', function( settings ) {
        settings.bind( function( to ) {
           set_prop( '.lf-header', '--header-bg-color', to);
        })
    });

    wp.customize( 'scr_title_colour', function(settings) {
        settings.bind( function(to) {
            if(to) {
               set_prop( '.c-site-branding__home-link', '--site-title-color', to);
            }
        })
    });

    wp.customize( 'scr_title_colour', function(settings) {
        settings.bind( function(to) {
            if(to) {
               set_prop( '.c-site-branding__home-link', '--site-title-color', to);
            }
        })
    });

    wp.customize( 'scr_tagline_colour', function(settings) {
        settings.bind( function(to) {
            if(to) {
               set_prop( '.lf-tagline', '--tagline-color', to);
            }
        })
    });

    wp.customize( 'scr_sidebar_bg_left', ( settings ) => {
        settings.bind((to) => {
            if(to) {
               set_prop( '.lf-sidebar-1', '--sidebar-bg-left', to);
            }
        });
    });

    wp.customize( 'scr_sidebar_bg_right', ( settings ) => {
        settings.bind((to) => {
            if(to) {
               set_prop( '.lf-sidebar-2', '--sidebar-bg-right', to);
            }
        });
    });

    wp.customize( 'scr_sidebar_color_left', ( settings ) => {
        settings.bind((to) => {
            if(to) {
               set_prop( '.lf-sidebar-1', '--sidebar-color-left', to);
            }
        });
    });

    wp.customize( 'scr_sidebar_color_right', ( settings ) => {
        settings.bind((to) => {
            if(to) {
               set_prop( '.lf-sidebar-2', '--sidebar-color-right', to);
            }
        });
    });

    wp.customize( 'scr_sidebar_color_left_links', ( settings ) => {
        settings.bind((to) => {
            if(to) {
               set_prop( '.lf-sidebar-1', '--sidebar-color-left-links', to);
            }
        });
    });

    wp.customize( 'scr_sidebar_color_right_links', ( settings ) => {
        settings.bind((to) => {
            if(to) {
               set_prop( '.lf-sidebar-2', '--sidebar-color-right-links', to);
            }
        });
    });

    //c-site-branding__tag-line

})();
